<template>
	<div />
</template>

<script>
import { getLoginKey } from '@/utils/auth';
// import { appId } from '@/utils';

var ua = navigator.userAgent;
var ISwxwork = ua.match(/wxwork/i) == 'wxwork';
let appId = ISwxwork ? 'ww0cbc29dad3b301f3' : 'wxf881d0e41dc44e79';

export default {
	data() {
		return {
			code: '8888'
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.code = this.getQueryString('code');
			if (!this.code) {
				const url =
					'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
					appId +
					'&redirect_uri=' +
					encodeURIComponent(window.location.href) +
					'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
				window.location.href = url;
			} else {
				this.login();
			}
		});
	},
	methods: {
		getQueryString(name) {
			let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
			let r = window.location.search.substr(1).match(reg);
			if (r !== null) {
				return r[2];
			} else {
				return '';
			}
		},
		login() {
			if (!getLoginKey()) {
				this.$store
					.dispatch('user/login', { code: this.code })
					.then(res => {
						if (res.errcode === 0) {
							this.$store.dispatch('user/GetUserInof').then(res => {
								if (res.errcode === 0) {
									const roles = [res.data.roleId];
									this.$store.dispatch('permission/generateRoutes', roles).then(() => {
										this.$router.addRoutes(this.$store.getters.addRouters);
										const { query } = this.$route;
										let redirect = query && query.redirect;
										if (redirect && Object.keys(query).length > 1) {
											let params = '';
											for (const k in query) {
												params += `&${k}=${query[k]}`;
											}
											params = params.replace('&', '?');
											redirect += params;
										}
										this.$router.push(redirect || '/');
									});
								}
							});
						} else {
							this.$toast.fail(res.errmsg);
						}
					})
					.catch(() => {
						console.log('logout');
					});
			} else {
				this.$router.push('/');
			}
		}
	}
};
</script>
